
/* NUM HEADER JS */
const header = document.querySelector('.js-header');
const viewportHeight = window.innerHeight;

const onScroll = () => {
  if (window.scrollY >= viewportHeight / 4) {
    document.body.classList.add('elements-scroll');
  } else {
    document.body.classList.remove('elements-scroll');
  }

  if (document.body.classList.contains('custom-product-page')) {
    window.addEventListener('scroll', () => {
      const viewportHeight = window.innerHeight;
      if (window.scrollY >= viewportHeight / 1) {
        document.body.classList.add('elements-scroll-product');
      } else {
        document.body.classList.remove('elements-scroll-product');
      }
    });
  }  
};

window.addEventListener('scroll', onScroll);

let lastScrollTop = 0; // Guarda la última posición del scroll

window.addEventListener("scroll", function () {
    let currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop) {
        // Scroll hacia abajo
        document.body.classList.add("scroll-down");

        document.querySelectorAll('.header__item-firstlevel').forEach(link => {
            link.classList.remove('submenu-open');
        });
    } else {
        // Scroll hacia arriba
        document.body.classList.remove("scroll-down");
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Evita valores negativos en el tope
}, false);



function menuBurger() {
  let burgerMenu = document.querySelector('.js-header-open-mobile');
  const items = document.querySelectorAll(".header__item-firstlevel");

  burgerMenu.addEventListener('click', function() {
    // Alternar las clases del botón burger
    this.classList.toggle('burger-menu__icon--active');
    this.classList.toggle('burger-menu__icon--not-active');

    // Alternar la clase para mostrar el menú
    document.body.classList.toggle('menu-open');
    document.body.classList.remove('search-open');
    document.body.classList.remove('filters-open');

    // Si el menú se abre
    if (document.body.classList.contains('menu-open')) {
      // Reiniciar las animaciones para que empiecen desde el estado inicial
      gsap.set(items, { opacity: 0, y: -20 });

      // Animación de los elementos con GSAP después de 500ms (para dar tiempo al menú de abrirse)
      setTimeout(function() {
        gsap.fromTo(items, 
          { opacity: 0, y: 20 }, // Estado inicial
          { 
            opacity: 1, 
            y: 0, 
            stagger: 0.2, // Retraso entre los elementos
            delay: 0, // Retraso antes de comenzar la animación
            duration: 1,
            ease: "power3.out" // Suavizado de la animación
          });
      }, 200); // Espera 500ms antes de iniciar la animación
    } else {
      // Si el menú se cierra, podemos ocultar los elementos de manera instantánea
      gsap.set(items, { opacity:  1, y: 0 });
    }
  });
}

menuBurger();



/**
 * Open and close menu mobile
 */
function searchRemoveClass() {
  let search = document.querySelector('.js-header-search');
  let burgerMenu = document.querySelector('.js-header-open-mobile');

  search.addEventListener('click', function() {
		document.body.classList.remove('menu-open');
    burgerMenu.classList.remove('burger-menu__icon--active');
	});
}

searchRemoveClass();

/**
 * Open and close submenu
 */
function openSubmenu() {
  let links = document.querySelectorAll('.js-open-submenu');

  links.forEach(function(link) {
      link.addEventListener('click', function(e) {
          e.preventDefault();

          links.forEach(function(otherLink) {
              if (otherLink !== link) {
                  otherLink.parentElement.classList.remove('submenu-open');
              }
          });

          this.parentElement.classList.toggle('submenu-open');
      });
  });

  document.addEventListener('click', function(event) {
      const isClickInside = event.target.closest('.header__item-firstlevel');

      if (!isClickInside) {
          links.forEach(function(link) {
              link.parentElement.classList.remove('submenu-open');
          });
      }
  });
}

openSubmenu();


/**
 * Reorder header elements on mobile: hamburger, search, logo, user icon, cart icon.
 * Moves the actual nodes (not clones) into `.header__mobile-bar` so listeners/IDs
 * stay intact, and restores them to their original spot when back on desktop.
 */
function setupMobileHeaderOrder() {
  const mobileBar = document.querySelector('.header__mobile-bar');
  if (!mobileBar || mobileBar.dataset.ready) return;
  mobileBar.dataset.ready = 'true';

  const items = [
    document.querySelector('.burger-menu'),
    document.querySelector('.header__search'),
    document.querySelector('.header__logo-mobile'),
    document.querySelector('.header__icon--user'),
    document.querySelector('#CartButton'),
  ].filter(Boolean);

  const placeholders = items.map((el) => {
    const marker = document.createComment('header-mobile-bar-placeholder');
    el.parentNode.insertBefore(marker, el);
    return { el, marker };
  });

  const mediaQuery = window.matchMedia('(max-width: 499px)');

  function applyLayout(e) {
    if (e.matches) {
      items.forEach((el) => mobileBar.appendChild(el));
    } else {
      placeholders.forEach(({ el, marker }) => {
        marker.parentNode.insertBefore(el, marker);
      });
    }
  }

  applyLayout(mediaQuery);
  mediaQuery.addEventListener('change', applyLayout);
}

setupMobileHeaderOrder();

